window.DECFabricCatalog = {
  "260gsm Cotton Lycra": {
    "widthCm": 158.0,
    "gsm": 260.0
  },
  "280gsm Cotton French Terry": {
    "widthCm": 158.0,
    "gsm": 280.0
  },
  "230gsm Bamboo Lycra": {
    "widthCm": 158.0,
    "gsm": 230.0
  },
  "Bamboo French Terry": {
    "widthCm": 158.0,
    "gsm": 300.0
  },
  "Bamboo Muslin/Gauze": {
    "widthCm": 142.0,
    "gsm": 135.0
  },
  "Cotton Satin": {
    "widthCm": 146.0,
    "gsm": 110.0
  },
  "Cotton Poplin": {
    "widthCm": 146.0,
    "gsm": 140.0
  },
  "Cotton Twill": {
    "widthCm": 146.0,
    "gsm": 150.0
  },
  "Cotton Canvas": {
    "widthCm": 146.0,
    "gsm": 250.0
  },
  "Cotton Muslin/Gauze": {
    "widthCm": 140.0,
    "gsm": 110.0
  },
  "Linen": {
    "widthCm": 133.0,
    "gsm": 190.0
  },
  "150gsm Rayon Woven": {
    "widthCm": 146.0,
    "gsm": 155.0
  },
  "PUL": {
    "widthCm": 150.0,
    "gsm": 170.0
  },
  "Softshell": {
    "widthCm": 143.0,
    "gsm": 325.0
  },
  "Sherpa": {
    "widthCm": 145.0,
    "gsm": 480.0
  },
  "Double Minky": {
    "widthCm": 150.0,
    "gsm": 280.0
  },
  "Stretch/Single Minky": {
    "widthCm": 155.0,
    "gsm": 240.0
  },
  "Stretch Rib Minky": {
    "widthCm": 155.0,
    "gsm": 240.0
  },
  "Squish": {
    "widthCm": 150.0,
    "gsm": 290.0
  },
  "Suede Cloth": {
    "widthCm": 155.0,
    "gsm": 200.0
  },
  "Microfiber Polar Fleece": {
    "widthCm": 155.0,
    "gsm": 200.0
  },
  "Polyester Towelling": {
    "widthCm": 146.0,
    "gsm": 250.0
  },
  "Non Stretch Velvet": {
    "widthCm": 148.0,
    "gsm": 280.0
  },
  "Polyester Stretch Velvet": {
    "widthCm": 146.0,
    "gsm": 200.0
  },
  "Double Brushed Polyester": {
    "widthCm": 155.0,
    "gsm": 260.0
  },
  "Sports Performance": {
    "widthCm": 155.0,
    "gsm": 300.0
  },
  "Swim Fabric": {
    "widthCm": 152.0,
    "gsm": 260.0
  },
  "200gsm Silky Jersey Recycled Polyester": {
    "widthCm": 155.0,
    "gsm": 210.0
  },
  "Double Sports Knit": {
    "widthCm": 155.0,
    "gsm": 280.0
  },
  "Bullet Fabric": {
    "widthCm": 158.0,
    "gsm": 250.0
  },
  "Athletic Wicking Jersey": {
    "widthCm": 155.0,
    "gsm": 140.0
  },
  "Polyester Stretch Mesh": {
    "widthCm": 160.0,
    "gsm": 90.0
  },
  "4X2 Rib": {
    "widthCm": 154.0,
    "gsm": 218.0
  },
  "Polyester 4 way Stretch Woven": {
    "widthCm": 145.0,
    "gsm": 130.0
  },
  "Peach skin-Boardshort": {
    "widthCm": 148.0,
    "gsm": 110.0
  },
  "Polyester Chiffon": {
    "widthCm": 146.0,
    "gsm": 65.0
  },
  "Polyester Satin/Sateen": {
    "widthCm": 146.0,
    "gsm": 80.0
  },
  "Polyester Corduroy": {
    "widthCm": 155.0,
    "gsm": 215.0
  },
  "Polyester Stretch Corduroy": {
    "widthCm": 150.0,
    "gsm": 287.0
  },
  "Oxford(Polyester Canvas)": {
    "widthCm": 148.0,
    "gsm": 220.0
  },
  "Polyester Stretch Sateen": {
    "widthCm": 146.0,
    "gsm": 80.0
  },
  "Rain Coat Fabric": {
    "widthCm": 150.0,
    "gsm": 80.0
  },
  "Vinyl leather 1.0 LZW": {
    "widthCm": 140.0,
    "gsm": 570.0
  },
  "Vinyl leather 1.0 SZW": {
    "widthCm": 140.0,
    "gsm": 570.0
  },
  "Smooth Shiny Vinyl(thin)": {
    "widthCm": 140.0,
    "gsm": 400.0
  },
  "Smooth Shiny Vinyl(thick)": {
    "widthCm": 140.0,
    "gsm": 440.0
  }
,
  "Poly Waffle Knit": {
    "widthCm": 185,
    "gsm": 200
  },
  "Heavy Double Brushed Poly": {
    "widthCm": 165,
    "gsm": 265
  },
  "Medium Double Brushed Poly": {
    "widthCm": 165,
    "gsm": 265
  },
  "Light Double Brushed Poly": {
    "widthCm": 165,
    "gsm": 265
  },
  "50S Modal Lycra": {
    "widthCm": 170,
    "gsm": 180
  },
  "180gsm Cotton Lycra": {
    "widthCm": 152,
    "gsm": 180
  },
  "320gsm Brushed Cotton French Terry": {
    "widthCm": 175,
    "gsm": 320
  },
  "Cotton Rib Knit": {
    "widthCm": 152,
    "gsm": 250
  },
  "Cotton Waffle Knit": {
    "widthCm": 150,
    "gsm": 260
  },
  "3x2 European Brushed Rib Fleece": {
    "widthCm": 165,
    "gsm": 210
  },
  "7x5 Poly Rib Knit": {
    "widthCm": 150,
    "gsm": 280
  },
  "Urban Rib": {
    "widthCm": 140,
    "gsm": 240
  }
};
